import React, { lazy } from "react";

import { VIEW_ACCOUNTS_PERMISSION } from "constants/permissions";

const ApnsPushCenterAssignPage = lazy(
  () => import("./ApnsPushCenterAssignPage"),
);

const apnsPushCenterAssignRoute = {
  path: "push_centers.apns_center",
  element: <ApnsPushCenterAssignPage />,
  root: false,
  permission: ["view_push_centers_apns", VIEW_ACCOUNTS_PERMISSION],
};

export default apnsPushCenterAssignRoute;
